module.exports = __webpack_public_path__ + "img/icon.5e28809a.png";